const isNumber = value => typeof value === 'number' && !Number.isNaN(value)

/**
 * Builds the one-paragraph read of the competitive position.
 *
 * Every claim is derived from the data — including the closing stance, which the
 * reference mockup hardcoded as "price leader" regardless of the numbers.
 */
export const buildVerdict = (mainData, mainName) => {
	if (!mainData || !Object.keys(mainData).length || !mainName) return null

	const { avgMarketRank, priceIndex, undercutBy } = mainData
	const rank = avgMarketRank?.value
	const brands = avgMarketRank?.lenCompetitors
	const cheapestPct = avgMarketRank?.cheapestPercentage

	if (!isNumber(rank) && !isNumber(priceIndex)) return null

	const delta = isNumber(priceIndex) ? priceIndex - 100 : null

	return {
		mainName,
		deltaText: isNumber(delta) ? `${delta >= 0 ? '+' : ''}${delta.toFixed(1)}%` : null,
		rankText: isNumber(rank) && brands ? `${rank.toFixed(1)} of ${brands}` : null,
		cheapestText: isNumber(cheapestPct) ? `cheapest on ${cheapestPct.toFixed(0)}% of dates` : null,
		isOftenCheapest: isNumber(cheapestPct) && cheapestPct >= 50,
		underText: undercutBy?.length
			? `Still undercut by: ${undercutBy.join(', ')}.`
			: 'No competitor undercuts you on most dates.',
		stanceText: isNumber(delta)
			? (delta <= 0
				? 'Positioned as a price leader in this set.'
				: 'Priced above the market in this set.')
			: null,
	}
}
